/* ============
 * Booking Transformer
 * ============
 */

import Transformer from './transformer';

export default class BookingTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      orderId: item.order_id,
      date: item.date,
      endTime: item.end_time,
      startTime: item.start_time,
      durations: item.durations,
    };
  }

  static send(item) {
    return {
      id: item.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/booking.js